module.exports = __webpack_public_path__ + "static/computers-ad457472941bff8435e3ebbeb8eb33e2.jpg";